import { render, staticRenderFns } from "./WorkStationList.vue?vue&type=template&id=16edfac2&scoped=true"
import script from "./WorkStationList.vue?vue&type=script&lang=js"
export * from "./WorkStationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16edfac2",
  null
  
)

export default component.exports